import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../Modal';

const PageModal = ({
  open,
  header,
  main,
  footer,
  hideCloseButton,
  shouldCloseOnOverlayClick,
  maxModalWidth,
  cardStyle,
  className,
  onClose,
}) => (
  <Modal
    open={open}
    hideCloseButton={hideCloseButton}
    closeButtonVersionButton
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    cardStyle={{ cardStyle, maxWidth: maxModalWidth }}
    modalClassName={cx('text-center page-modal', className)}
    modalContentClass=""
    onClose={onClose}
  >
    <div className="d-flex flex-column">
      {header && (
        <div className="page-modal-header">
          <h1 className="page-modal-header-title">{header}</h1>
        </div>
      )}
      <div className="page-modal-main">
        {main}
      </div>
      {footer && (
        <div className="page-modal-footer">
          {footer}
        </div>
      )}
    </div>
  </Modal>
);

PageModal.propTypes = {
  open: PropTypes.bool,
  header: PropTypes.node,
  main: PropTypes.node,
  footer: PropTypes.node,
  hideCloseButton: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  maxModalWidth: PropTypes.number,
  cardStyle: PropTypes.object,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default memo(PageModal);
